/**
 * Copyright (c) 2021, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

import React from "react";
import ReactDOM from "react-dom";
import { App } from "./app";
import "./assets/styles/index.css";
import "rsuite/dist/rsuite.min.css";
import ConfigProvider from "./providers/config-provider";

ReactDOM.render(
    <React.StrictMode>
        <ConfigProvider>
            <App />
        </ConfigProvider>
    </React.StrictMode>,
    document.getElementById("root")
);
